module.exports = __webpack_public_path__ + "static/media/assignVehicle.7745adb2.svg";